import { useState, useEffect } from "react";
import {
  useDebounce,
  formatString,
  buildItineraryTimes,
} from "../helpers/GetAQuoteHelpers";

export default function useTripForm(isOther, locations, tripType) {
  const [formData, setFormData] = useState({
    uploadedFiles: [],
    specialRequests: "",
    pax: null,
    groupType: null,
    busType: null,
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    company: "",
    agreeToSms: false,
    otherDate: null,
    duration: null,
    city: "",
    host: "",
    phoneIsValid: false,
    useDiy: null,
  });

  const debouncedSpecialRequests = useDebounce(formData.specialRequests, 1000);
  const debouncedPax = useDebounce(formData.pax, 1000);
  const debouncedFirstName = useDebounce(formData.firstName, 1000);
  const debouncedLastName = useDebounce(formData.lastName, 1000);
  const debouncedEmail = useDebounce(formData.email, 1000);
  const debouncedPhone = useDebounce(formData.phone, 1000);
  const debouncedCompany = useDebounce(formData.company, 1000);

  const updateFormField = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const isValidEmail = () => {
    if (!formData.email) return false;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(formData.email);
  };

  let tripInfoData = {};

  if (isOther) {
    tripInfoData = {
      date_of_travel: formData.otherDate,
      city: formData.city,
      duration: formData.duration,
      comments: debouncedSpecialRequests,
      "est._number_of_passengers": debouncedPax,
      group_type: formData.groupType,
      preferred_bus_type: formData.busType,
    };
  } else {
    tripInfoData = {
      comments: debouncedSpecialRequests,
      "est._number_of_passengers": debouncedPax,
      group_type: formData.groupType,
      preferred_bus_type: formData.busType,
    };
  }

  const contactInfoData = {
    first_name: debouncedFirstName,
    last_name: debouncedLastName,
    email: debouncedEmail,
    phone: debouncedPhone,
    company: debouncedCompany,
    agree_to_sms: formData.agreeToSms,
  };

  const hasAdditionalDetails = Object.values(tripInfoData).some((value) => {
    if (value === null || value === undefined) return false;

    if (typeof value === "string") return value.trim() !== "";

    return true;
  });

  const calculatedLocations = () => {
    const times = buildItineraryTimes(locations);
    return locations.map((loc, i) => ({ ...loc, times: times[i] }));
  };

  const tripInfoDataParam = encodeURIComponent(JSON.stringify(tripInfoData));
  const stringifiedLocations = encodeURIComponent(
    JSON.stringify(calculatedLocations()),
  );

  const tripTypeTitle = () => {
    if (tripType === "shuttle") {
      return "Continuous local shuttle";
    } else {
      return formatString(tripType);
    }
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.host) {
        setFormData((prev) => ({
          ...prev,
          host: event.data.host,
        }));
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return {
    formData,
    updateFormField,
    isValidEmail,
    contactInfoData,
    hasAdditionalDetails,
    tripInfoData,
    tripInfoDataParam,
    stringifiedLocations,
    tripTypeTitle,
  };
}
